import React from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {ActionLink, Label, Panel, DownloadLink} from 'components';
import BankingChequeHelperModal from './BankingChequeHelperModal';
import EditBankingInfoModal from './EditBankingInfoModal';
import {t} from 'shared/core';
import EmployeeProfileContainer from '../../EmployeeProfileContainer';
import {calendarDate} from 'shared/tools';

const ToggleBankingInfoButton = observer(({uiState}) => {
  if (uiState.bankingInformationHidden) {
    return (
      <ActionLink onClick={() => uiState.showBankingInformation()}>
          <FormattedMessage id='employees.profile.banking.Show'/>
      </ActionLink>
    );
  }

  return (
    <ActionLink onClick={() => uiState.hideBankingInformation()}>
        <FormattedMessage id='employees.profile.banking.Hide'/>
    </ActionLink>
  );
});

const BankingContainer = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <EmployeeProfileContainer uiState={uiState}>
      <div className='fs-hide'>
        <Panel.Stack loose>
          <Panel>
            <Panel.Header title={t('employees.profile.banking.Banking Information')}>
              <ToggleBankingInfoButton uiState={uiState}/>
              {uiState.editDataPermission('::BANKING_INFORMATION') &&
                <ActionLink onClick={() => uiState.openBankingInfoModal()} className='ml2'>
                  <FormattedMessage id='employees.profile.banking.Edit'/>
                </ActionLink>}
            </Panel.Header>
            <div className='clearfix mxn1 py1'>
              <div className='col col-6 px1'>
                <FormattedMessage id='employees.profile.banking.Social Insurance Number (SIN)' />
              </div>
              <div className='col col-6 px1'>
                <Label
                  model={employee}
                  path='sin'
                  render={value => uiState.formatMaskedValue(value, uiState.bankingInformationHidden)}
                />
              </div>
            </div>
            {employee.sinExpiryDate && <div className='clearfix mxn1 py1'>
              <div className='col col-6 px1'>
                <FormattedMessage id='employees.profile.banking.Date of Expiry (SIN)'/>
              </div>
              <div className='col col-6 px1'>
                <Label
                  model={employee}
                  path='sinExpiryDate'
                  render={value => uiState.formatMaskedValue(calendarDate(value), uiState.bankingInformationHidden)}
                />
              </div>
            </div>}
            <div className='clearfix mxn1 pb1'>
              <div className='col col-6 px1'>
                <FormattedMessage id='employees.profile.banking.Bank Account Nickname' />
              </div>
              <div className='col col-6 px1'>
                <Label
                  model={employee}
                  path='bankAccount.nickname'
                  render={value => uiState.formatMaskedValue(value, uiState.bankingInformationHidden)}
                />
              </div>
            </div>
            <div className='clearfix mxn1 pb1'>
              <div className='col col-6 px1'>
                <FormattedMessage id='employees.profile.banking.Institution Number' />
              </div>
              <div className='col col-6 px1'>
                <Label
                  model={employee}
                  path='bankAccount.institutionNumber'
                  render={value => uiState.formatMaskedValue(value, uiState.bankingInformationHidden)}
                />
              </div>
            </div>
            <div className='clearfix mxn1 pb1'>
              <div className='col col-6 px1'>
                <FormattedMessage id='employees.profile.banking.Transit Number' />
              </div>
              <div className='col col-6 px1'>
                <Label
                  model={employee}
                  path='bankAccount.transitNumber'
                  render={value => uiState.formatMaskedValue(value, uiState.bankingInformationHidden)}
                />
              </div>
            </div>
            <div className='clearfix mxn1 pb1'>
              <div className='col col-6 px1'>
                <FormattedMessage id='employees.profile.banking.Account Number' />
              </div>
              <div className='col col-6 px1'>
                <Label
                  model={employee}
                  path='bankAccount.accountNumber'
                  render={value => uiState.formatMaskedValue(value, uiState.bankingInformationHidden)}
                />
              </div>
            </div>
            {!uiState.bankingInformationHidden && employee.bankAccount.cheque && <div className='clearfix mxn1 pb1'>
              <div className='col col-6 px1'>
                <FormattedMessage id='employees.profile.banking.Uploaded Cheque' />
              </div>
              <div className='col col-6 px1'>
                <DownloadLink
                  href={employee.bankAccount.cheque.link('url')}
                  title={t('employees.profile.banking.Download')}
                />
              </div>
            </div>}
            <ActionLink onClick={() => uiState.openBankingChequeHelper()} className='dodger TextLink block mt2'>
              <FormattedMessage id='employees.profile.banking.How do I find my banking information from a cheque?'/>
            </ActionLink>
          </Panel>
          <Panel>
            <Panel.Header title={t('employees.profile.banking.Please Note')}/>
            <div className='pb1 jumbo'>
              <FormattedMessage id='employees.profile.banking.We collect your banking info so that we can easily add you to payroll or other services that require direct deposit.'/>
            </div>
            <div className='pt1 jumbo'>
              <FormattedMessage id="employees.profile.banking.If your payroll or banking information changes, enter your new information here and we'll make sure payroll is updated."/>
            </div>
          </Panel>
        </Panel.Stack>
        <BankingChequeHelperModal uiState={uiState} />
        <EditBankingInfoModal uiState={uiState} />
      </div>
    </EmployeeProfileContainer>
  );
});

export default BankingContainer;
